import { render, staticRenderFns } from "./FirstShiftFaqDialog.vue?vue&type=template&id=60571957&scoped=true"
import script from "./FirstShiftFaqDialog.vue?vue&type=script&lang=ts"
export * from "./FirstShiftFaqDialog.vue?vue&type=script&lang=ts"
import style0 from "./FirstShiftFaqDialog.vue?vue&type=style&index=0&id=60571957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60571957",
  null
  
)

export default component.exports